<template>
  <div>
    <component
      :is="theme"
      v-if="isReady"
      :my-tribus-embed="myTribusEmbed"
      v-bind="defaultProps"
    />
  </div>
</template>

<script>
import { Client, Contact } from 'displet-sdk-js';
import { defineAsyncComponent, markRaw } from 'vue';

import Property from './models/Property';
import tailwindConfig from '../../tailwind.config';

import sampleData from './sampleData';
import getPropertyPhotos from './themes/default/helpers/getPropertyPhotos';
import getBrytescoreListing from './helpers/brytescore';

export default {
  name: 'App',

  data() {
    return {
      isReady: false,
      myTribusEmbed: null,
      themes: {
        default: markRaw(defineAsyncComponent(() => import('./themes/default/Theme.vue'))),
      },
    };
  },

  computed: {
    /** @type {object} */
    defaultProps() {
      const isDev = (process.env.NODE_ENV === 'development');

      const {
        DEFAULT_PROPS = isDev ? sampleData : {},
      } = window;

      return {
        ...DEFAULT_PROPS,
        isDev,
        isBranded: !window.location.pathname.startsWith('/share'),
        property: new Property(DEFAULT_PROPS.property),
        theme: 'default',
      };
    },

    /** @type {object} */
    theme() {
      return this.themes[this.defaultProps.theme];
    },
  },

  async created() {
    this.setupMyTribusEmbed();

    this.isReady = true;
  },

  mounted() {
    this.brytescoreViewedListing();
  },

  methods: {
    primaryPhoto() {
      return getPropertyPhotos(this.defaultProps.property)
        .find((photo) => photo).media_url;
    },
    brytescoreViewedListing() {
      window.brytescore('realestate.viewedListing', {
        listing: getBrytescoreListing(this.defaultProps.property),
      });
    },
    /** @return {void} */
    setupMyTribusEmbed() {
      const { MyTribusEmbed } = window;
      this.myTribusEmbed = new MyTribusEmbed({
        networkUid: this.defaultProps.networkUid,
        primaryColor: tailwindConfig.theme.extend.colors.primary,
        secondaryColor: tailwindConfig.theme.extend.colors.secondary,
        websiteJwt: this.defaultProps.authToken,
      });

      window.myTribusEmbedInstance = this.myTribusEmbed;

      this.myTribusEmbed.on('auth.set', async () => {
        await this.$store.commit('auth/setContact', new Contact(this.myTribusEmbed.getContact()));
        this.$store.dispatch('auth/fetchAgent');
      });

      this.myTribusEmbed.on('auth.unset', () => {
        this.$store.commit('auth/unsetContact');
        this.$store.commit('auth/unsetAgent');
      });

      Client.HTTP_CLIENT.interceptors.request.use(async (config) => {
        const token = this.myTribusEmbed.isAuthenticated()
          ? this.myTribusEmbed.getContactJwt()
          : this.defaultProps.authToken;

        return {
          ...config,
          headers: {
            ...config.headers,
            Authorization: `Bearer ${token}`,
          },
        };
      }, (error) => Promise.reject(error));
    },
  },
};
</script>
